import { Turnstile } from '@marsidev/react-turnstile';
type Props = {
  freebie : {
    title: string;
    description?: string;
    allowMultipleDownloadsPerEmail:boolean;
  };
  name: string;
  email: string;
  onNameChange: (v: string) => void;
  onEmailChange: (v: string) => void;
  onClaim: () => void;
  isSubmitting: boolean;

  captchaToken: string | null;
  onCaptchaSuccess: (token: string) => void;
  onCaptchaExpire: () => void;
};

export const FreebieCard = ({
  freebie,
  name,
  email,
  onNameChange,
  onEmailChange,
  onClaim,
  isSubmitting,
  captchaToken,
  onCaptchaSuccess,
  onCaptchaExpire,
}: Props) => (
  <div className="freebie-card">
    <div className="freebie-card__header">
      <p className="freebie-card__kicker">Gratis nedladdning</p>
      <h1>{freebie.title}</h1>
      {freebie.description && <p className="freebie-card__description">{freebie.description}</p>}
    </div>

    {/* CAPTCHA – alltid */}
      <div className="freebie-card__captcha">
        <Turnstile
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY!}
          onSuccess={onCaptchaSuccess}
          onExpire={onCaptchaExpire}
          options={{ theme: "light" }}
        />
        </div>
    <input
      type="text"
      placeholder="Ditt namn"
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      className="freebie-card__input"
      style={{ marginBottom: '12px' }}
    />
    <input
      type="email"
      placeholder="Din e-post"
      value={email}
      onChange={(e) => onEmailChange(e.target.value)}
      className="freebie-card__input"
    />
    <p className="freebie-card__note">
      Genom att ladda ner gåvan accepterar du att få nyhetsbrev och erbjudanden via e-post. Du kan alltid avregistrera dig längst ned i mailet.
    </p>
    {freebie.allowMultipleDownloadsPerEmail === false && (
  <p className="freebie-card__note">
    Den här gåvan kan laddas ner en gång per person.
  </p>
)}

      <button
        onClick={onClaim}
        disabled={
          isSubmitting ||
          !captchaToken ||
          name.trim().length === 0 ||
          email.trim().length === 0
        }
        className="freebie-card__button"
      >
        {isSubmitting ? "Förbereder…" : "Hämta gratis"}
      </button>
  </div>
);
